import React from "react";
import styles from './custom-tag.module.scss';
import Chip from "@mui/material/Chip";
import cls from "classnames";

const CustomTag = (props) => {
    return <Chip className={cls(styles.customTag, props?.additionalClass)} {...props} />
}

export default CustomTag;
